<template template>
  <div v-if="treeObj" class="mind-container">
    <!-- 悬浮工具栏 -->
    <div class="restart-search">
      <el-tooltip class="item" effect="dark" content="文章收录" placement="top">
        <i class="el-icon-monitor" @click="handleArticleCollect"></i>
      </el-tooltip>
      <el-tooltip trigger="hover" popper-class="menu-tooltip" placement="top">
        <ul slot="content" class="menu-list">
          <li @click="addMindVisible = true">新建脑图</li>
          <li @click="handleAddNote">新建笔记</li>
          <li @click="handleAddDraft">新建白板</li>
          <li @click="handleAddTimeline">新建时间轴</li>
        </ul>
        <i class="el-icon-document-add"/>
      </el-tooltip>
      <el-tooltip effect="dark" content="论文矩阵">
        <img src="https://bookor-formal.oss-cn-beijing.aliyuncs.com/aaavvv.png" @click="handleToAtom" />
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="查看文档" placement="bottom">
        <img
          class="doc-switch"
          src="@/assets/editor/switchdoc.png"
          alt=""
          @click="handleRestartSearch"
        >
      </el-tooltip>
    </div>
    <!-- 查看文档抽屉 -->
    <SearchBar :searchDrawer="showDocDrawer" @updateSearchDrawer="showDocDrawer = $event" />
    <!-- 文章收录弹窗 -->
    <el-dialog
      title="文章收录"
      :visible.sync="showCollectDialog"
      width="500px"
      :close-on-click-modal="false"
      :show-close="true"
    >
      <div style="padding: 20px 0;">
        <el-input
          v-model="collectUrl"
          placeholder="请输入文章链接"
          clearable
          size="medium"
          style="width: 100%;"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="showCollectDialog = false">取消</el-button>
        <el-button type="primary" @click="handleCollectConfirm">收录</el-button>
      </span>
    </el-dialog>
    <!-- 新建脑图弹窗 -->
    <el-dialog title="新增脑图" :visible.sync="addMindVisible" width="40%">
      <el-input v-model="mindTitle" placeholder="请输入脑图名称" maxlength="20" show-word-limit clearable />
      <span slot="footer" class="dialog-footer">
        <el-button @click="addMindVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddMindMap">确 定</el-button>
      </span>
    </el-dialog>

    <Mind :treeObj="treeObj" :readonly="readonly"/>
    

    <el-dialog
      title="温馨提示"
      custom-class="mind-dialog"
      :visible.sync="dialogVisible"
      width="66%"
      :close-on-click-modal="false"
      :show-close="false">
      <span>感谢您之前的关注！该作者暂时关闭了该脑图的分享功能，若您仍有需要，欢迎随时联系该作者～</span>
    </el-dialog>

  </div>
</template>
<script>
import axios from "@/http";
import Mind from '@/components/Echarts/src/TreePlan/mind.vue';
import request from '@/http/request';
import SearchBar from '@/components/editor/searchBar.vue';
export default {
  data() {
    return {
      treeObj: null,
      dialogVisible: false,
      readonly: false,
      addMindVisible: false,
      mindTitle: '',
      showCollectDialog: false,
      collectUrl: '',
      showDocDrawer: false,

    }
  },
  components: {
      Mind,
      SearchBar
  },
  methods: {
    handleAddMindMap() {
      if(!this.mindTitle) {
        this.$message.error('请输入脑图名称')
        return
      }
      const userInfo = JSON.parse(localStorage.getItem('userinfo'))
      this.addMindVisible = false
      axios.post('/ai/mind/add', {
          title: this.mindTitle,
          memberId: userInfo.userid
      }).then(res => {
        if(res.code === 200) {
          this.$message.success('添加成功')
          window.open(`#/mind/${res.data}`, '_blank');
        } else {
          this.$message.error('添加失败')
        }
      })
    },
    handleAddNote() {
      this.$router.push({
        name: 'note',
        query: { paperId: '' }
      })
    },
    handleAddDraft() {
      this.$router.push({
        name: 'draft',
        query: { id: '' }
      })
    },
    handleAddTimeline() {
      this.$router.push({
        name: 'Timeline'
      })
    },
    handleToAtom() {
      this.$router.push('/papermatrix')
    },
    handleRestartSearch() {
      this.showDocDrawer = true;
    },
    handleArticleCollect() {
      this.showCollectDialog = true;
      this.collectUrl = '';
    },
    handleCollectConfirm() {
      if (!this.collectUrl) {
        this.$message.error('请输入文章链接');
        return;
      }
      request('/api/Keywords/gatherMemberNoteByUrl', {
        url: this.collectUrl
      }).then((result) => {
        this.$message.success('收录成功');
        this.showCollectDialog = false;
        // 存储内容到 vuex
        this.$store.commit('SET_URL_CONTENT', result);
        // 跳转到 note 页面
        this.$router.push({
          name: 'note',
          query: { origin: 'Crawling' }
        });
      }).catch((err) => {
        this.$message.error(err?.message || '收录失败');
      });
    },

  },
  mounted() {
    const route = this.$route
    if(route?.query?.share) {
      this.readonly = true
    }
    const mindId = this.$route.params.id; // 获取 URL 中的 id 参数
    if(!mindId) {
      return
    }
    if(route?.query?.share) {
      axios({
        url: `/ai/mind/get?id=${mindId}`,
        method: "get",
      }).then((res) => {
        if(res.code === 200){
          const data = res.data
          if(!!data.is_share) {
            this.dialogVisible = true
          }
          this.treeObj = {
            detail: data?.detail,
            mind_map_id: mindId
          }
        }
      })
    } else {
      request('/mobile/Nokeyinterface/getMindMapContentList', {mind_map_id: mindId}, 'get').then(res => {
      if(res && res.length) {
        this.treeObj = res[0]
      } else {
        this.treeObj = {
          detail: null,
          mind_map_id: mindId
        }
      }
    })
    }

  }
}
</script>

<style lang="scss" scoped>
.mind-container{
  :deep(.mind-dialog .el-dialog__body){
    height: 500px;
    font-size: 18px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  :deep(.mind-dialog .el-dialog__body span){
    position: relative;
    top: -40px;
  }
}
.v-modal{
  opacity: 0.8;
}
.restart-search{
  position: fixed;
  top: 48%;
  left: 4px;
  width: 70px;
  height: 40px;
  flex-wrap: wrap;
  display: flex;
  gap: 4px;
  z-index: 100;
  i{
    font-size: 28px;
    cursor: pointer;
  }
  img{
    cursor: pointer;
    width: 30px;
    height: 30px;
  }
}
.menu-tooltip{
  padding: 0;
}
.menu-list{
  li{
    height: 30px;
    line-height: 30px;
    padding: 5px 15px;
    border-radius: 4px;
    cursor: pointer;
    &:hover{
      background-color: #111;
    }
  }
}


</style>
